'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _VerticalAlignTopOutlined = _interopRequireDefault(require('./lib/icons/VerticalAlignTopOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _VerticalAlignTopOutlined;
exports.default = _default;
module.exports = _default;